import { IcActive } from './ic-active.js';
import { IcDisabled } from './ic-disabled.js';
import { IcInactive } from './ic-inactive.js';
import { IcInformational } from './ic-informational.js';
import { IcNegative } from './ic-negative.js';
import { IcNegativeWhiteBorder } from './ic-negative-white-border.js';
import { IcPositive } from './ic-positive.js';
import { IcPositiveWhiteBorder } from './ic-positive-white-border.js';
import { IcWarning } from './ic-warning.js';
import { IcWarningWhiteBorder } from './ic-warning-white-border.js';

const svgMap = {
  negative: {
    none: IcNegative,
    "white-border": IcNegativeWhiteBorder
  },
  positive: {
    none: IcPositive,
    "white-border": IcPositiveWhiteBorder
  },
  warning: {
    none: IcWarning,
    "white-border": IcWarningWhiteBorder
  },
  active: {
    none: IcActive,
    "white-border": IcActive
  },
  disabled: {
    none: IcDisabled,
    "white-border": IcDisabled
  },
  inactive: {
    none: IcInactive,
    "white-border": IcInactive
  },
  informational: {
    none: IcInformational,
    "white-border": IcInformational
  }
};

export { svgMap };
//# sourceMappingURL=svg-map.js.map
